import {SELECT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: SELECT,
  attribute: 'rent_after_balance_is_paid',
  label: {
    default: 'Rent After Balance Is Paid',
    short: 'Rent After Balance',
  },
  options: [
    {key: 'yes', label: 'YES'},
    {key: 'no', label: 'NO'},
    {key: 'na', label: 'N/A'},
  ],
});
